<template>
  <div class="product-directory">
    <ban :urls="urls" :tabs="tabs" @change="(item, index) => onBanChanged(item, index)" menu="pd"></ban>
    <div class="page-container">
      <el-carousel class="shoufengqin" style="height: 750px" arrow="never" :autoplay="false" ref="carousel" indicator-position="none" :initial-index="tabIndex">
        <el-carousel-item>
          <div class="body-container description">
            <p v-if="language === '2'">
              Licorice products are used in food and beverage to eliminate undesirable aftertaste, extend sweetness, enhance flavor and improve mouthfeel.They are widely used in a variety of applications including confections，preserved fruits, biscuits, seasonings, soy sauce, beverages and healthy food.
            </p>
            <div v-else>
              <p>甘草制品具有消除不良余味，增强并延长甜味，增强香味，改善口感的特点。广泛应用于糖果蜜饯、饼干、调味品、酱油、腌制品,饮料及健康食品。</p>
            </div>
          </div>
          <div class="info-area">
            <el-collapse v-model="footIndex" accordion>
              <el-collapse-item  v-for="(item, index) in foods" :key="index" :name="`${index}`" :style="{'background-color': colors[index % 4], opacity: 0.9}">
                <template slot="title">
                  <!-- <div class="title">{{language === '1' ? item.name : item.enName}}</div> -->
                  <p class="sub-title">{{language === '1' ? item.name : item.enName}}</p>
                </template>
                <div class="box">
                  <div v-if="language === '2'">
                    <p v-if="item.molecularFormula"><span>Molecular formula: </span><span v-html="item.molecularFormula"></span></p>
                    <p v-if="item.CAS"><span>CAS#: </span>{{item.CAS}}</p>
                    <p v-if="item.enIngredients"><span>ingredients: </span>{{item.enIngredients}}</p>
                    <p><span>Content: </span>{{item.content}}</p>
                    <p><span>Character: </span>{{item.enCharacter}}</p>
                    <p v-if="item.enFeatures"><span>Product features: </span>{{item.enFeatures}}</p>
                  </div>
                  <div v-else>
                    <p v-if="item.molecularFormula"><span>分子式：</span><span v-html="item.molecularFormula"></span></p>
                    <p v-if="item.CAS"><span>CAS#：</span>{{item.CAS}}</p>
                    <p v-if="item.ingredients"><span>主要成分：</span>{{item.ingredients}}</p>
                    <p><span>含量：</span>{{item.content}}</p>
                    <p><span>性状：</span>{{item.character}}</p>
                    <p v-if="item.features"><span>产品特点：</span>{{item.features}}</p>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="body-container description">
            <p v-if="language === '2'">Licorice products are used in the personal care industry to provide the functions of skin whitening, reducing inflammation, moisturizing and acne treatment, thickening agent, inhibition of sebum secretion. They are widely used in facial masks, skin creams, sunscreens, hand creams, shower gel, shampoo, lip balm, oral care products.</p>
            <p v-else>甘草制品在日化类产品中具有美白、抗过敏、消炎、防晒、修复保湿、祛痘、增稠、抑制皮脂分泌、覆盖不良余味等作用。广泛应用于面膜、护肤乳霜、防晒霜、护手霜、沐浴露、洗发水、唇膏、口腔护理产品等。</p>
          </div>
          <div class="info-area">
            <el-collapse v-model="rihuaIndex" accordion>
              <el-collapse-item  v-for="(item, index) in personalCare" :key="index" :name="`${index}`" :style="{'background-color': colors[index % 4], opacity: 0.9}">
                <template slot="title">
                  <!-- <div class="title">{{language === '1' ? item.name : item.enName}}</div> -->
                  <p class="sub-title">{{language === '1' ? item.name : item.enName}}</p>
                </template>
                <div class="box">
                  <div v-if="language === '2'">
                    <p><span>Molecular formula: </span><span v-html="item.molecularFormula"></span></p>
                    <p><span>CAS#: </span>{{item.CAS}}</p>
                    <p><span>INCI：</span>{{item.INCIEN}}</p>
                    <p v-if="item.enSource"><span>Plant source:</span>{{item.enSource}}</p>
                    <p>
                      <span>Content({{item.tipEN || item.tipCN}}): </span>
                      {{item.content}}
                    </p>
                    <p><span>Character: </span>{{item.enCharacter}}</p>
                    <p v-if="item.suggestions"><span>Dissolve suggestions: </span>{{item.suggestions}}</p>
                    <p><span>Product features: </span>{{item.enFeatures}}</p>
                    <p v-if="item.enFunctions"><span>Main function: </span>{{item.enFunctions}}</p>
                    <p><span>Dosage and scope: </span>{{item.enRange}}</p>
                  </div>
                  <div v-else>
                    <p><span>分子式：</span><span v-html="item.molecularFormula"></span></p>
                    <p><span>CAS#：</span>{{item.CAS}}</p>
                    <p><span>INCI：</span>{{item.INCICN || item.INCIEN}}</p>
                    <p v-if="item.source"><span>植物来源：</span>{{item.source}}</p>
                    <p><span>含量({{item.tipCN || item.tipEN}})：</span>{{item.content}}</p>
                    <p><span>性状：</span>{{item.character}}</p>
                    <p><span>产品特点：</span>{{item.features}}</p>
                    <p v-if="item.functions"><span>主要作用：</span>{{item.functions}}</p>
                    <p><span>用量及范围：</span>{{item.range}}</p>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
          <!-- <Cosmetic class="body-container" :directory="personalCare"></Cosmetic> -->
        </el-carousel-item>
      </el-carousel>
      <div class="test"></div>
    </div>
    <!-- footer -->
    <Footer></Footer>
  </div>
</template>

<script>
import Ban from '@/components/sub-page-banner.vue'
// import Cosmetic from './components/Cosmetic.vue'
// import Food from './components/Foods.vue'
import Footer from '@/components/Footer'

export default {
  components: { Ban, Footer },
  data () {
    let { type } = this.$route.query
    type = parseInt(type)
    return {
      tabIndex: type || 0,
      personalCare: [
        {
          name: '甘草酸二钾',
          enName: 'Dipotassium glycyrrhizinate (DPG)',
          molecularFormula: 'C<sub>42</sub>H<sub>60</sub>K<sub>2</sub>O<sub>16</sub>',
          CAS: '68797-35-3',
          INCICN: '甘草酸二钾',
          INCIEN: 'Dipotassium Glycyrrhizate',
          content: '65%，72%，75%',
          tipCN: 'HPLC',
          character: '白色结晶粉末，有特殊甜味。',
          enCharacter: 'white crystalline powder with characteristic sweet taste.',
          features: '水溶性好、低残醇、无过敏原。',
          enFeatures: 'good water solubility, low residue alcohol, no allergen.',
          functions: '抗氧化，抗敏，抗溃疡、消炎、舒缓敏感肌肤。',
          enFunctions: 'Anti-oxidative, stabilizer, hypoallergenic, calms and soothes skin, for sensitive skin.',
          range: '在化妆品行业，可用于护肤霜，润肤水，沐浴露，祛斑霜，面膜等，有美容\r\n护肤作用。在日化行业，可用于牙膏、洗发水。建议使用量为0.1-0.5%. 客户可按自身产品的要求做适当调整。',
          enRange: 'In the cosmetic industry, it can be used to formulate skin cream, lotion, shower gel, anti-freckle cream, facial mask, etc. In the personal care industry, it can be used for toothpaste, shampoo. Suggested dosage is from 0.1-0.5%. Add appropriate amount as per production requirements.',
          id: 'Dipotassium'
        },
        {
          name: '甘草酸铵',
          enName: 'Mono Ammonium Glycyrrhizinate (MAG)',
          molecularFormula: 'C<sub>42</sub>H<sub>61</sub>O<sub>16</sub>NH<sub>4</sub>',
          CAS: '53956-04-0',
          INCICN: '甘草酸铵',
          INCIEN: 'Ammonium Glycyrrhizate',
          content: '≥65%',
          tipCN: 'HPLC',
          character: '白色结晶性粉末，有特殊甜味。',
          enCharacter: 'white crystalline powder with characteristic sweet taste.',
          features: '醇溶性好、无过敏原。',
          enFeatures: 'good alcohol solubility, high sweetness, no allergens.',
          functions: '舒缓肌肤、提亮肤色，改善日化用品不适气味',
          enFunctions: 'calms and soothes skin, assists with providing brighter smoother skin, improves flavor of personal care products.',
          range: '在日化行业中，建议使用量为0.1-1.0%。',
          enRange: 'In the personal care industry, the recommended usage is 0.1-1.0%.',
          id: 'Mono'
        },
        {
          name: '甘草酸',
          enName: 'Glycyrrhizic Acid (GA)',
          molecularFormula: 'C<sub>42</sub>H<sub>62</sub>O<sub>16</sub>',
          CAS: '1405-86-3',
          INCICN: '甘草酸',
          INCIEN: 'Glycyrrhizic Acid',
          content: '≥96%',
          tipCN: 'UV',
          character: '白色结晶粉末，有特殊甜味。',
          enCharacter: 'white crystalline powder with characteristic sweet taste.',
          features: '醇溶性好、可溶于水、无过敏原',
          enFeatures: 'good alcohol solubility, water solubility, no allergen',
          functions: '舒缓肌肤、抗敏、抗炎、修复、减少肌肤粗糙、清除超氧离子和羟基自由基。',
          enFunctions: 'calms and soothes skin, assists with providing brighter smoother skin, improves flavor of personal care products.',
          range: '日化。按生产需求适量添加。',
          enRange: 'personal care. Add appropriate amount as per production requirements.',
          id: 'Glycyrrhizic'
        },
        {
          name: '甘草亭酸',
          enName: '18-β Glycyrrhetinic Acid',
          molecularFormula: 'C<sub>30</sub>H<sub>46</sub>O<sub>4</sub>',
          CAS: '471-53-4',
          INCICN: '甘草亭酸',
          INCIEN: 'Glycyrrhetinic Acid',
          content: '98.0-101.0%',
          tipCN: '电位滴定',
          tipEN: 'Potentiometric titration',
          encontent: '(Potentiometric titration): 98.0-101.0%',
          character: '白色结晶粉末',
          enCharacter: 'White crystalline powder',
          features: '醇溶性好、无过敏原',
          enFeatures: 'good alcohol solubility, no allergen',
          functions: '抗炎、抗敏、美白。亦可用于口腔产品有效预防和消除牙龈炎症、口腔溃疡。',
          enFunctions: 'Calms and soothes skin, assists with repairing, replenishing and rejuvenating skin, supports the skin barrier.',
          range: '各类护肤品、化妆品、牙膏、香皂、洗头膏等护肤品。建议使用量为0.05~0.5%。',
          enRange: 'all kinds of skin care products, cosmetics, toothpaste, soap, shampoo and other skin care products. The recommended usage is 0.05 ~ 0.5%.',
          id: 'Glycyrrhetinic'
        },
        {
          name: '硬脂醇甘草亭酸酯',
          enName: 'Stearyl Glycyrrhetinate',
          molecularFormula: 'C<sub>48</sub>H<sub>82</sub>O<sub>4</sub>',
          CAS: '13832-70-7',
          INCICN: '硬脂醇甘草亭酸酯',
          INCIEN: 'Stearyl Glycyrrhetinate',
          content: '95%-102%',
          tipCN: 'UV',
          character: '白色结晶粉末',
          enCharacter: 'White crystalline powder',
          features: '酯溶性好、亲肤性好、渗透吸收作用强。',
          enFeatures: 'good ester solubility, good skin affinity, strong penetration and absorption.',
          functions: '提亮肤色，补水，舒缓敏感肌肤。',
          enFunctions: 'Brightening, hydrating, for sensitive skin, assists with providing a smooth complexion.',
          range: '适用于油溶性或膏霜乳类化妆品、护肤品。建议用量为0.05-1.0%，可按照产品的要求做适当的调整。',
          enRange: 'applicable to oil soluble cosmetics, skin care products. The recommended dosage is 0.05-1.0%, which can be adjusted according to production requirements.',
          id: 'Stearyl'
        },
        {
          name: '光甘草定',
          enName: 'Glabridin',
          molecularFormula: 'C<sub>20</sub>H<sub>20</sub>O<sub>4</sub>',
          CAS: '59870-68-7',
          INCICN: '光果甘草（Glycyrrhiza Glabra）根提取物',
          INCIEN: 'Glycyrrhiza Glabra (Licorice) Root Extract',
          content: '≥10%，≥40%，≥90%',
          tipCN: 'HPLC',
          source: '光果甘草',
          enSource: 'glabra licorice root',
          character: '棕黄色至棕红色或类白色粉末（三种规格）',
          enCharacter: 'brown or white powder（three specifications）',
          features: '光甘草定是光果甘草中所含有的一种特异性异黄酮成分，常规产品溶于丙二醇、丁二醇等有机溶剂；光甘草定的改性包裹物，易溶于水，可直接在水系化妆品中添加，且稳定性好。',
          enFeatures: 'a specific isoflavone component contained in glycyrrhiza glabra licorice root. Regular product is soluble in propylene glycol, butanediol and other organic solvents.  Glabridin 10%-15% is easily soluble in water and can be directly added to water cosmetics with good stability.',
          functions: '具有很强的络氨酸酶生成及活性抑制作用，有天然美白黄金之称。帮助对抗肤色不均匀，祛除色斑，提亮肤色，使肌肤更光滑，抗氧化。',
          enFunctions: 'Help combat discoloration and uneven skin tone, assist with providing brighter, smoother looking skin, anti-oxidative.',
          range: '建议添加量：0.05-5.0‰，客户可按自身产品的要求做适当调整。',
          enRange: 'Suggested dosage: 0.05-5.0‰, customers can make appropriate adjustments according to the production requirements.',
          id: 'Glabridin'
        }
      ],
      foods: [{
        name: '甘草酸铵',
        enName: 'Monoammonium Glycyrrhizinate(MAG)',
        molecularFormula: `C<sub>42</sub>H<sub>61</sub>O<sub>16</sub>NH<sub>4</sub>`,
        CAS: '53956-04-0',
        // ingredients: '铵化甘草酸',
        // enIngredients: 'Ammonium Glycyrrhizic Acid',
        content: '（HPLC）≥65%',
        tipCN: 'HPLC',
        character: '白色结晶性粉末，有特殊甜味。',
        enCharacter: 'white crystalline powder with characteristic sweet taste',
        features: '醇溶性好、高甜度、甜味持久，无过敏原。',
        enFeatures: 'good alcohol solubility, high sweetness, enhance and extend sweetness, no allergens.',
        id: 'Monoammonium'
      },
      {
        name: '甘草酸一钾',
        enName: 'Monopotassium Glycyrrhizinate',
        molecularFormula: 'C<sub>42</sub>H<sub>61</sub>KO<sub>16</sub>',
        CAS: '68039-19-0',
        content: '(UV) ≥90%',
        tipCN: 'UV',
        character: '类白色结晶粉末，有特殊甜味',
        enCharacter: 'white crystalline powder with characteristic sweet taste',
        features: '具有易溶于水、甜度高、甜味持久、训盐增鲜的效果',
        enFeatures: 'freely soluble in water, high sweetness, extending sweetness, salt reducing and fresh increasing effect',
        id: 'Monopotassium'
      },
      {
        name: '甘草酸',
        enName: 'Glycyrrhizic Acid（GA）',
        molecularFormula: 'C<sub>42</sub>H<sub>62</sub>O<sub>16</sub>',
        CAS: '1405-86-3',
        content: '(UV) ≥96%',
        tipCN: 'UV',
        character: '白色结晶粉末，有特殊甜味。',
        enCharacter: 'white crystalline powder with characteristic sweet taste',
        features: '醇溶性好、可溶于水、无过敏原',
        enFeatures: 'good alcohol solubility, soluble in water, no allergens.',
        id: 'Glycyrrhizic'
      },
      {
        name: '甘草酸胺',
        enName: 'Ammoniated Glycyrrhizin',
        ingredients: '氨化甘草酸',
        enIngredients: 'Ammonium Glycyrrhizin',
        content: '（HPLC）30%-40%',
        tipCN: 'HPLC',
        character: '黄色至棕黄色粉末，有特殊的甘草香味和甜味。',
        enCharacter: 'yellow or brownish yellow powder with characteristic licorice flavor and sweetness.',
        features: '溶解性好、味甜、增香、无过敏原。',
        enFeatures: 'good water solubility, extending sweetness, enhancing flavor, no allergens.',
        id: 'Ammoniated'
      },
      {
        name: '甘草提取物粉(甘草甜素R19, 甘草甜素R21)',
        enName: 'GYE（R19, R21）',
        content: '（HPLC）10%-20%',
        tipCN: 'HPLC',
        character: '棕黄色或淡黄色粉末，有特殊甜味',
        enCharacter: 'pale brown or pale yellow powder with characteristic sweet taste, freely soluble in water',
        features: '具有水溶性好、甜味持久、训盐增鲜',
        enFeatures: 'With good water solubility, extending sweetness, salt reducing and fresh increasing effect.',
        id: 'GYE'
      },
      {
        name: '甘草酸三钾',
        enName: 'Tripotassium Glycyrrhizinate',
        molecularFormula: 'C<sub>42</sub>H<sub>59</sub>K<sub>3</sub>O<sub>16</sub>',
        CAS: '68797-35-3',
        content: '（HPLC）≥10%',
        tipCN: 'HPLC',
        character: '棕黄色粉末',
        enCharacter: 'Pale brown powder',
        features: '具有水溶性好、甜味持久、训盐增鲜、去异压腥的效果',
        enFeatures: 'With good water solubility, extending sweetness, salt reducing and fresh increasing effect, eliminating undesirable taste.',
        id: 'Tripotassium'
      }, {
        name: '甘草提取物（粉、浸膏）',
        enName: 'Licorice Extract Powder/Semi-Fluid/Blocks',
        content: '（HPLC）≥6%',
        tipCN: 'HPLC',
        character: '棕色粉末或棕黑色液体、固体，有甘草特殊的香味',
        enCharacter: 'brown powder or brownish black liquid or solid with slight licorice flavor',
        id: 'Licorice'
      }],
      tabs: [{
        title: '食品类',
        titleEN: 'Foods',
        isActive: !type
      }, {
        title: '日化类',
        titleEN: 'Personal Care',
        isActive: type
      }],
      urls: [
        [
          require('../../assets/img/sub-banner/shipin1.jpg'),
          require('../../assets/img/sub-banner/shipin2.jpg'),
          require('../../assets/img/sub-banner/shipin3.jpg')
        ],
        [
          require('../../assets/img/sub-banner/rihua1.jpg'),
          require('../../assets/img/sub-banner/rihua2.jpg'),
          require('../../assets/img/sub-banner/rihua3.jpg')
        ]
      ],
      colors: ['#006838', '#754c29', '#abc662', '#67bfed'],
      footIndex: '0',
      rihuaIndex: '0'
    }
  },
  computed: {
    language () {
      return this.$store.state.language || '1'
    }
  },
  mounted () {
    this.arrivals()
  },
  methods: {
    mouseOver (type, index) {
      this[type] = index
    },
    onBanChanged (item, index) {
      this.tabIndex = index
      this.$refs.carousel.setActiveItem(index)
    },
    arrivals () {
      this.$nextTick(() => {
        const { id } = this.$route.query
        const e = document.getElementById(id)
        if (e) {
          window.scrollTo({
            top: this.heightToTop(e),
            behavior: 'smooth'
          })
        }
      })
    },
    heightToTop (ele) {
      // ele为指定跳转到该位置的DOM节点
      let root = document.body
      let height = 0
      do {
        height += ele.offsetTop
        ele = ele.offsetParent
      } while (ele !== root)
      return height - 100
    }
  }
}
</script>

<style lang="less" scoped>
.product-directory {
  margin-top: 88px;
  .page-container {
    width: 1280px;
    margin: 0 auto;
  }
  .el-carousel {
    height: 1300px;
    overflow: hidden;
    ::v-deep .el-carousel__container {
      height: 100% !important;
    }
  }
  .description {
    padding: 50px 0;
    box-sizing: border-box;
    p {
      &:last-child {
        margin-bottom: 20px;
      }
    }
  }
  .info-area {
    width: 1280px;
    margin: 0 auto;
    .el-collapse {
      width: 1000px;
      margin: 0 auto;
      border: none;
      .el-collapse-item {
        /deep/ .el-collapse-item__header {
          color: #fff;
          background-color: transparent;
          padding-left: 20px;
        }
        // /deep/ .el-collapse-item__header {
        //   background: url("../../assets/img/xfq-bg.jpeg") repeat-y center center fixed;/* 与上面的 bg 中的background设置一样 */
        //   background-size: 1000% 200%;
        //   filter: blur(5px) contrast(0.9);  /* 值越大越模糊 */
        //   z-index:-1;  /* 模糊层在最下面 */
        // }
        /deep/ .el-collapse-item__content {
          padding-bottom: 0;
        }
        .title {
          font-weight: bold;
        }
        .box {
          font-size: 14px;
          padding-top: 20px;
          writing-mode: horizontal-tb;
          color: #333;
          overflow: hidden;
          padding: 15px;
          box-sizing: content-box;
        }
      }
    }
    img {
      margin-top: 50px;
    }
  }
  .sub-title {
    font-size: 20px;
    font-weight: bold;
  }
  .shoufengqin {
    margin-bottom: 200px;
  }
}
</style>
